import { useQuery } from 'react-query';
import { getUserAssessmentSubmission } from '../apis/assessment';
import { UIUserAssessment } from '../../../../packages/types/src/userAssessment';
export const useAssessmentSubmission = (publishedItemId?: string) => {
	return useQuery({
		queryKey: ['useAssessmentSubmission', publishedItemId],
		queryFn: async () => (await getUserAssessmentSubmission({ publishedItemId })).data.userAssessment as UIUserAssessment,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!publishedItemId,
	});
};
